/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { LanguageProvider } from './src/hooks/useLanguage';

/**
 * 防止浏览器扩展（如Solana钱包）与开发环境冲突
 * Prevent browser extensions (like Solana wallets) from conflicting with development environment
 */
export const onClientEntry = () => {
  // 在开发环境中防护window对象属性冲突
  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
    // 创建一个防护函数来处理只读属性错误
    const originalDefineProperty = Object.defineProperty;
    Object.defineProperty = function(obj, prop, descriptor) {
      try {
        return originalDefineProperty.call(this, obj, prop, descriptor);
      } catch (error) {
        // 如果是只读属性错误，静默处理
        if (error.message.includes('Cannot assign to read only property')) {
          console.warn(`Extension conflict detected for property: ${prop}. Ignoring assignment.`);
          return obj;
        }
        throw error;
      }
    };
  }
};

export const wrapRootElement = ({ element }) => {
  return <LanguageProvider>{element}</LanguageProvider>;
};
